import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useMaterialUIController } from "context";
import { useState } from "react";
import getText from "Translator";

export default function DateComponent(props) {
  const {
    question,
    editQuestionHandle,
    helpPage,
    fileInfo,
    openSelectDate,
    setFocuse,
  } = props;
  const [controller, dispatch] = useMaterialUIController();
  return (
    <Grid
      item
      xs={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      sm={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      md={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      style={{
        position: question.fixTop || question.fixBottom ? "fixed" : "unset",
        left: question.fixTop || question.fixBottom ? 0 : "unset",
        right: question.fixTop || question.fixBottom ? 0 : "unset",
        top: question.fixTop ? 0 : "unset",
        bottom: question.fixBottom ? 0 : "unset",
        paddingBottom: question.fixTop || question.fixBottom ? 10 : "unset",
        backgroundColor:
          question.fixTop || question.fixBottom ? "#FFF" : "unset",
        zIndex: question.fixTop || question.fixBottom ? 999 : "unset",
        paddingTop: question.fixTop ? 55 : question.fixBottom ? 10 : "unset",
        paddingBottom: question.fixBottom ? 55 : question.fixTop ? 10 : "unset",
        paddingRight: question.fixTop || question.fixBottom ? 15 : "unset",
        paddingLeft: question.fixTop || question.fixBottom ? 15 : "unset",

        marginTop:
          question.titleType === 2 ? 8 : question.displayTitle ? 5 : 8,
        marginBottom: question.helpPage ? -15 : 0,
        display:
          question.showForUser === true && question.visible ? "" : "none",
          paddingInlineEnd: question.size && question.size !== 12 ? 3 : "unset",

      }}
    >
      {question.titleType === 1 && question.displayTitle && (
        <b>{question.text}</b>
      )}
      {question.allowCopy && question.copyValue && (
        <ContentCopyIcon
          onClick={() => {
            if (question.useranswer == question.copyValue) {
              editQuestionHandle(question, "");
            } else {
              editQuestionHandle(question, question.copyValue);
            }
          }}
          style={{
            color: "#039dfc",
            height: 20,
            width: 25,
            position: "relative",
            right: "fa" == "en" ? 0 : "none",
            left: "fa" == "fa" ? 0 : "none",
            top: 15,
            float: "fa" == "en" ? "right" : "left",
            cursor: "pointer",
            zIndex: 999,
          }}
        />
      )}
      <FormControl style={{ width: "100%" }} variant="outlined">
        {question.titleType === 2 && (
          <InputLabel htmlFor="outlined-adornment-password">
            {question.text}
          </InputLabel>
        )}
        <OutlinedInput
          onClick={() => {
            if (fileInfo.limitedFile === false) {
              openSelectDate(question);
            }
          }}
          onTouchStart={() => {
            setFocuse(question.code);
          }}
          onMouseDown={() => {
            setFocuse(question.code);
          }}
          readOnly={true}
          value={
            question.useranswerText === "Invalid inputs" ||
            question.useranswerText === ""
              ? " "
              : question.useranswerText
          }
          label={question.titleType === 2 ? question.text : null}
        />
      </FormControl>
      {question.helpPage && (
        <Button
          style={{
            marginTop: -10,
          }}
          onClick={() => {
            helpPage(question.helpPage);
          }}
          className="helplink"
          fullWidth={true}
        >
          <div
            style={{
              width: "100%",
              fontSize: 11,
              textAlign: "fa" == "fa" ? "left" : "right",
            }}
          >
            {question.helpText === ""
              ? getText("helptext", "fa")
              : question.helpText}
          </div>
        </Button>
      )}
    </Grid>
  );
}
